var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Service } from "@cxp-shared/platform/Service";
import { CommonDataServiceName } from "@cxp-shared/services/CDS";
import { PerformanceServiceName } from "@cxp-shared/services/Performance";
import { TelemetryServiceName } from "@cxp-shared/services/Telemetry";
import { CIStatus } from "./EnvironmentConfiguration.Types";
var EnvironmentConfigurationPluralName = "msdynmkt_configurations";
var MarketingConfigurationPluralName = "msdyncrm_marketingconfigurations";
var EnvironmentConfigurationService = /** @class */ (function (_super) {
    __extends(EnvironmentConfigurationService, _super);
    function EnvironmentConfigurationService() {
        return _super.call(this) || this;
    }
    EnvironmentConfigurationService.prototype.serviceStart = function (appContext) {
        _super.prototype.serviceStart.call(this, appContext);
        this.cds = appContext.getService(CommonDataServiceName);
        this.telemetryService = appContext.getService(TelemetryServiceName);
        this.performanceService = appContext.getService(PerformanceServiceName);
    };
    EnvironmentConfigurationService.prototype.getCIStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var perfScenario, result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        perfScenario = this.performanceService.startScenario("Perso EnvironmentConfigurationService.GetCIStatus");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.cds.getRecords(EnvironmentConfigurationPluralName)];
                    case 2:
                        result = _a.sent();
                        this.telemetryService.logFunctionalEvent("Perso_GET_CIStatus", {
                            ciStatus: result[0].msdynmkt_cistatus
                        });
                        perfScenario.complete({ ciStatus: result[0].msdynmkt_cistatus });
                        return [2 /*return*/, result[0].msdynmkt_cistatus];
                    case 3:
                        e_1 = _a.sent();
                        perfScenario.throw(e_1.message, e_1.name);
                        return [2 /*return*/, CIStatus.NotConfigured];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    EnvironmentConfigurationService.prototype.getSolutionsOnly = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                /*const perfScenario = this.performanceService.startScenario("Perso EnvironmentConfigurationService.getSolutionsOnly");
        
                try {
                    const response = await this.cds.getRecords<IMarketingConfiguration>(MarketingConfigurationPluralName);
                    const result = response?.[0]?.msdyncrm_isinstallcomplete == null || response[0].msdyncrm_isinstallcomplete === false;
                    this.telemetryService.logFunctionalEvent("Perso_GET_SolutionsOnly", {
                        solutionsOnly: result
                    });
                    perfScenario.complete({ solutionsOnly: result });
                    return result;
                } catch (e) {
                    perfScenario.throw(e.message, e.name);
                    return false;
                }*/
                // This broke Sales personalization scenario on some orgs
                // We need to discuss if this is still needed, perso dialog should not be diagnosing org state
                return [2 /*return*/, false];
            });
        });
    };
    return EnvironmentConfigurationService;
}(Service));
export { EnvironmentConfigurationService };
